import React from 'react';
import * as Styles from './IconFolder.styles';

const IconFolder = () => (
  <Styles.Svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="IconFolder">
    <path d="M13.5 7L12.3845 4.76892C12.0634 4.1268 11.9029 3.80573 11.6634 3.57116C11.4516 3.36373 11.1963 3.20597 10.9161 3.10931C10.5992 3 10.2402 3 9.52229 3H5.7C4.5799 3 4.01984 3 3.59202 3.21799C3.21569 3.40973 2.90973 3.71569 2.71799 4.09202C2.5 4.51984 2.5 5.0799 2.5 6.2V7M2.5 7H17.7C19.3802 7 20.2202 7 20.862 7.32698C21.4265 7.6146 21.8854 8.07354 22.173 8.63803C22.5 9.27976 22.5 10.1198 22.5 11.8V16.2C22.5 17.8802 22.5 18.7202 22.173 19.362C21.8854 19.9265 21.4265 20.3854 20.862 20.673C20.2202 21 19.3802 21 17.7 21H7.3C5.61984 21 4.77976 21 4.13803 20.673C3.57354 20.3854 3.1146 19.9265 2.82698 19.362C2.5 18.7202 2.5 17.8802 2.5 16.2V7Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Styles.Svg>

);

export default IconFolder;
